<template>
  <modal
    class="addRetainershipModal"
    name="addOldUser"
    transition="pop-out"
    :width="modalWidth"
    :height="450"
    @opened="opened"
    @closed="closed"
  >
    <div class="retainership__box">
      <button
        type="button"
        class="close modal-close"
        aria-label="Close"
        @click="closeModal"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="text-center">
        <h3 class="mt-5 add__retainership__header">
          {{ $t("text.addOldUser.addExistingUser") }}
        </h3>
        <div class="add__retainership__form__wrapper">
          <div class="price_change_input_wrapper">
            <input
              type="text"
              :placeholder="$t('text.form.email')"
              v-model="email"
              class="border-0"
              @blur="validateUser"
            />
          </div>
          <div
            v-show="!$route.query.category"
            class="mt-4 text-center display-flex align-items-center justify-content-center"
          >
            <!-- <b-form-group label="select access level" v-slot="{ ariaDescribedby }">
                    <b-form-radio-group
                      id="radio-group-1"
                      v-model="selected"
                      :options="options"
                      :aria-describedby="ariaDescribedby"
                      name="radio-options"
                    ></b-form-radio-group>
                </b-form-group> -->
            <select v-model="selected">
              <option value="select access level" disabled selected>
                {{ $t("text.addOldUser.selectAcessLevel") }}
              </option>
              <option
                :value="group.name"
                v-for="(group, i) in options"
                :key="i"
              >
                {{ group.name }}
              </option>
            </select>
          </div>
          <!-- <div class="mt-4" v-if="selected === 'Branch'">
            <div class="price_change_input_wrapper">
              <model-select
                :options="branches"
                class="w-100"
                v-model="branchId"
                placeholder="select branch"
              >
              </model-select>
            </div>
          </div> -->
          <div
            class="mt-4"
            v-if="
              selected !== 'Company' &&
              selected !== 'Dealer Admin' &&
              selected !== 'Industry' &&
              selected !== 'select access level'
            "
          >
            <!-- <select v-model="newId"> -->
            <select v-model="branchId">
              <option value="Please Select" disabled selected>
                {{ $t("text.addOldUser.select") }} {{ selected }}
              </option>
              <!-- <option
                value="Please Select"
                disabled
                selected
                v-if="selected == 'Dealers'"
              >
                Select Dealer
              </option>
              <option
                value="Please Select"
                disabled
                selected
                v-if="selected == 'Regional Manager'"
              >
                Select Region
              </option>
              <option
                value="Please Select"
                disabled
                selected
                v-if="selected == 'Regional Engineer'"
              >
                Select Regional Engineer
              </option>
              <option
                value="Please Select"
                disabled
                selected
                v-if="selected == 'Sales Rep'"
              >
                Select Sales Rep
              </option> -->
              <option
                :value="cList.id"
                v-for="(cList, i) in categoryLists"
                :key="i"
              >
                {{ cList.name }}
              </option>
            </select>
          </div>

          <div class="mt-5 text-center" v-if="showSubmitBtn">
            <button
              class="ep-btn ep-primary"
              @click="addUser($event)"
              :disabled="isButtonDisabled ? true : null"
              :style="[
                isButtonDisabled
                  ? { cursor: 'not-allowed' }
                  : { cursor: 'pointer' },
              ]"
            >
              {{ $t("text.addOldUser.addUser") }} <span></span>
            </button>
            <img
              src="@/assets/img/git_loader.gif"
              style="display: none"
              width="35px"
              class="ml-3 loader"
            />
          </div>
          <div class="mt-5 text-center" v-else>
            <p>
              {{ $t("text.addOldUser.alreadyMapped") }} <br />
              {{ $t("text.addOldUser.alreadyMapped2") }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import configObject from "@/config";
import JQuery from "jquery";
let $ = JQuery;
import "vue-search-select/dist/VueSearchSelect.css";
import { ModelSelect } from "vue-search-select";

const MODAL_WIDTH = 656;

export default {
  name: "addOldUser",
  props: {
    company: Object,
    users: Array,
    companyID: String,
  },
  components: {
    ModelSelect,
  },
  data() {
    return {
      modalWidth: MODAL_WIDTH,
      email: null,
      isButtonDisabled: false,
      branchId: "Please Select",
      // branches: [],
      showSubmitBtn: true,
      selected: "select access level",
      options: [],
      categoryLists: [],
      // options: [
      //   { text: "Company", value: "Company" },
      //   { text: "Branch", value: "Branch" },
      // ],
    };
  },
  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },
  mounted() {},
  watch: {
    selected() {
      // this.getGroupRoles();
      if (
        this.selected !== "Company" &&
        this.selected !== "Dealer Admin" &&
        this.selected !== "Industry" &&
        this.selected !== "select access level"
      ) {
        this.getCategotyLists();
      }
    },
  },

  methods: {
    opened() {
      this.getRoleGroups();
      if (this.$route.query.category) {
        this.selected = this.$route.query.category;
        // this.getCategotyLists();
      }
      // this.getBranches();
    },
    getCategotyLists() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/DealerBranchGroup/${
            this.$route.query.companyID
              ? this.companyID
              : this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }/${
            this.$route.query.category
              ? this.$route.query.category
              : this.selected
          }`,
          configObject.authConfig()
        )
        .then((res) => {
          let index = 0;
          res.data.sort((a, b) => {
            return a.name.toLowerCase() > b.name.toLowerCase()
              ? 1
              : b.name.toLowerCase() > a.name.toLowerCase()
              ? -1
              : 0;
          });
          this.categoryLists = res.data;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    getRoleGroups() {
      // this.showLoader = true;
      let url;
      if (this.$route.query.companyID) {
        url = `${configObject.apiBaseUrl}/Role/GroupCategories/GENSYS`;
      } else {
        url = `${configObject.apiBaseUrl}/Role/GroupCategories/EPUMP`;
      }
      this.axios
        .get(url, configObject.authConfig())
        .then((res) => {
          let index = 0;
          res.data.sort((a, b) => {
            return a.name.toLowerCase() > b.name.toLowerCase()
              ? 1
              : b.name.toLowerCase() > a.name.toLowerCase()
              ? -1
              : 0;
          });

          this.options = res.data;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    // getBranches() {
    //   this.axios
    //     .get(
    //       `${configObject.apiBaseUrl}/Company/Branches/${
    //         this.$route.query.companyId
    //           ? this.$route.query.companyId
    //           : this.company.id
    //       }`,
    //       configObject.authConfig()
    //     )
    //     .then((res) => {
    //       res.data.sort((a, b) => {
    //         return a.name.toLowerCase() > b.name.toLowerCase()
    //           ? 1
    //           : b.name.toLowerCase() > a.name.toLowerCase()
    //           ? -1
    //           : 0;
    //       });

    //       this.branches = res.data;
    //       this.branches.forEach((el) => {
    //         el.text = el.name;
    //         el.value = el.id;
    //       });
    //     })
    //     .catch((error) => {});
    // },
    validateUser() {
      const user = this.users.filter((user) => user.email === this.email);
      if (user.length) {
        if (user[0].branchRoles[0].role !== "Company") {
          // this.options[1].disabled = true
          this.showSubmitBtn = false;
        }
      }
    },

    closed() {
      // this.options[1].disabled = true
      this.showSubmitBtn = true;
      this.selected = "select access level";
      this.branchId = "Please Select";
      this.email = null;
    },
    validEmail(email) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return true;
      }
      return false;
    },
    closeModal() {
      this.$modal.hide("addOldUser");
    },
    addUser($event) {
      $event.preventDefault();
      if (!this.email) {
        this.$toast.open({
          message: this.$t("text.errors.emailMissing"),
          type: "error",
          duration: 3000,
        });
        return;
      } else if (!this.validEmail(this.email)) {
        this.$toast.open({
          message: this.$t("text.errors.invalidEmail"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      // if (!this.company.id) {
      //   this.company.id = this.companyID;
      // }
      let data = {
        email: this.email,
        roleCategory: this.selected,
        id:
          this.selected !== "Company" &&
          this.selected !== "Dealer Admin" &&
          this.selected !== "Industry"
            ? this.branchId
            : this.company.id,
      };

      this.isButtonDisabled = true;
      $(".loader").show();
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Company/AddUserTo`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          this.$toast.open({
            message: this.$t("text.addOldUser.usedAdded"),
            type: "success",
            duration: 5000,
          });
          $(".loader").hide();
          this.isButtonDisabled = false;
          this.closeModal();
          this.$eventHub.$emit("getCUsersModal", this.email);
          data = null;
          this.email = null;
        })
        .catch((error) => {
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
          this.closeModal();
          this.isButtonDisabled = false;
          $(".loader").hide();
        });
    },
  },
};
</script>
